import React from 'react';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { RegistroUsuario } from '../components/RegistroUsuario';
import { Container } from 'react-bootstrap';

function FormularioRegistroUsuario() {

    return (
        <>
            <Header />
            <Container className="mt-5" fluid="md">
                <RegistroUsuario />
            </Container>
            <div>
                <img style={{ width: '100%', maxWidth: '100%' }} src={process.env.REACT_APP_SERVER_IMAGE + 'estaticas/medios-pago.webp'} alt="medios de pago" />
            </div>
            <Footer />
        </>
    );
}

export { FormularioRegistroUsuario };